import { HttpContext, HttpContextToken } from '@angular/common/http'

export interface IRecaptureContext {
    key?: string
}

export interface RecaptureContext {
    context?: HttpContext
    enabled: boolean
}
export const RECAPTURE_ENABLED = new HttpContextToken<IRecaptureContext>(() => ({
    key: undefined,
}))

export function withRecapture(key: string, context?: HttpContext): HttpContext {
    return (context ?? new HttpContext()).set(RECAPTURE_ENABLED, {
        key: key,
    })
}
